"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Spinner_1 = require("Views/Shared/Components/Spinner/Spinner");
const withSpinner = (WrappedComponent) => {
    const SpinnerHOC = (_a) => {
        var { loading } = _a, props = tslib_1.__rest(_a, ["loading"]);
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: loading ? ((0, jsx_runtime_1.jsx)("div", { className: "spinner-wrapper relative h-screen", children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, { visible: true, className: "spinner absolute !top-18" }) })) : ((0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props))) }));
    };
    return SpinnerHOC;
};
exports.default = withSpinner;
